module.exports = __webpack_public_path__ + "/images/cover-landing-noel.df953a0.webp";